import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { providerApi } from "../../api/providerApi"
import { Alert, Spin, Collapse, Card } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { ClientApi } from "../../api/clientApi"
import { AdminApi } from "../../api/adminsApi"
const { Panel } = Collapse;

const ShowAdminView = () => {
    const {id} = useParams()
    const [admin, setAdmin] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };

    useEffect(() => {
        // Définir la fonction fetchAdmin à l'intérieur de useEffect
        const fetchAdmin = async () => {
          setLoading(true);
          setError(null);
          try {
            const res = await AdminApi.getAdmin(`${id}`,abortController.signal);
            setAdmin(res.data); // Stocker les données récupérées

            console.log("details",res.data)
          } catch (err) {
            setError("Impossible de charger les détails de l'admin.");
          } finally {
            setLoading(false);
          }
        };
    
        fetchAdmin(); // Appeler la fonction immédiatement
    
      }, [id]);
      


    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails de l'admin</h1>
            <Link to={`/gestion-admins/liste`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && admin && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations personnelles" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom :</strong> {admin.name} {admin.lastname}</p>
                <p><strong>Email :</strong> {admin.email || "Non fourni"}</p>
                {/* <p><strong>Numéro de téléphone :</strong> {admin.contact || "Non fourni"}</p> */}
                

                <p><strong>Date d'ajout :</strong> {formatDate(admin.created_at)}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Role" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Niveau de permission :</strong> {admin.role_id || "Non fournie"}</p>
                {/* <p><strong>Ville :</strong> {admin.ville || "Non fournie"}</p> */}

              </div>
            </Panel>
          </Collapse>

        </div>
      )}
    </div>
  </MainLayout>

}
export default ShowAdminView